import * as React from 'react';

import type { InstructorsUnapprovedContextValue } from './InstructorsUnapprovedContext.types';

import { InstructorsUnapprovedContext } from './InstructorsUnapprovedProvider';

export function useInstructorsUnapprovedData(): InstructorsUnapprovedContextValue {
  const context = React.useContext(InstructorsUnapprovedContext);

  if (!context) {
    throw new Error(
      'useInstructorsUnapprovedData must be used within InstructorsUnapprovedProvider'
    );
  }

  return context;
}
